import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const posts = [{
  slug: 'kitchen-renovation-trends-2025',
  title: 'Top 5 Kitchen Renovation Trends 2025',
  image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80',
  excerpt: 'Discover the latest trends shaping modern kitchen designs.',
  content: `
      <h2>The Future of Kitchen Design</h2>
      <p>As we move into 2025, kitchen design continues to evolve with innovative trends that blend functionality with luxury aesthetics. Here are the top 5 trends transforming modern kitchens:</p>
      <h3>1. Smart Kitchen Technology</h3>
      <p>Integration of IoT devices, smart appliances, and voice-controlled systems are becoming standard in luxury kitchens. From refrigerators that track inventory to ovens you can control from your phone, technology is revolutionizing the cooking experience.</p>
      <h3>2. Sustainable Materials</h3>
      <p>Eco-friendly materials like recycled glass countertops, bamboo cabinetry, and low-VOC paints are gaining popularity. Homeowners are increasingly conscious of their environmental impact.</p>
      <h3>3. Bold Color Palettes</h3>
      <p>Move over white kitchens - deep blues, emerald greens, and warm terracotta tones are making a statement. Two-tone cabinetry creates visual interest and personality.</p>
      <h3>4. Integrated Storage Solutions</h3>
      <p>Hidden pantries, pull-out spice racks, and custom drawer organizers maximize space efficiency while maintaining a clean, minimalist aesthetic.</p>
      <h3>5. Statement Lighting</h3>
      <p>Oversized pendant lights and sculptural chandeliers serve as functional art pieces, adding drama and sophistication to kitchen spaces.</p>
      <p>Ready to transform your kitchen? Contact Renova8 & Build for a consultation on bringing these trends to your home.</p>
    `,
  date: 'January 15, 2025',
  author: 'Renova8 Design Team'
}, {
  slug: 'luxury-flooring-guide',
  title: 'How to Choose Luxury Flooring for Your Home',
  image: 'https://images.unsplash.com/photo-1615873968403-89e068629265?w=800&q=80',
  excerpt: 'Expert tips on selecting the perfect flooring materials.',
  content: `
      <h2>The Foundation of Luxury Living</h2>
      <p>Choosing the right flooring is crucial for creating a luxurious and cohesive home design. Here is your comprehensive guide to selecting premium flooring materials:</p>
      <h3>Hardwood Flooring</h3>
      <p>Timeless and elegant, hardwood floors add warmth and value to any home. Consider species like oak, maple, or exotic woods like Brazilian cherry for unique character. Wide planks are trending for a modern, spacious feel.</p>
      <h3>Engineered Wood</h3>
      <p>Offers the beauty of hardwood with enhanced stability and moisture resistance. Perfect for areas where solid hardwood might not be suitable, like basements or kitchens.</p>
      <h3>Luxury Vinyl Plank (LVP)</h3>
      <p>Modern LVP mimics natural materials beautifully while offering superior durability and waterproofing. Ideal for high-traffic areas and busy households.</p>
      <h3>Natural Stone</h3>
      <p>Marble, travertine, and limestone create stunning, one-of-a-kind floors. Each piece is unique, adding natural beauty and sophistication to your space.</p>
      <h3>Porcelain Tile</h3>
      <p>Available in countless designs, including wood-look and marble-look options. Extremely durable and low-maintenance, perfect for bathrooms and kitchens.</p>
      <h3>Key Considerations</h3>
      <ul>
        <li>Lifestyle and foot traffic patterns</li>
        <li>Maintenance requirements</li>
        <li>Budget and long-term value</li>
        <li>Climate and moisture levels</li>
        <li>Overall design aesthetic</li>
      </ul>
      <p>Our team at Renova8 & Build can help you select and install the perfect flooring for your luxury renovation project.</p>
    `,
  date: 'January 10, 2025',
  author: 'Renova8 Design Team'
}, {
  slug: 'modern-bathroom-renovation-ideas',
  title: 'Bathroom Renovation Ideas for Modern Homes',
  image: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&q=80',
  excerpt: 'Transform your bathroom into a luxurious spa-like retreat.',
  content: `
      <h2>Creating Your Personal Spa Sanctuary</h2>
      <p>Modern bathroom design goes beyond functionality - it is about creating a serene retreat where you can relax and rejuvenate. Here are innovative ideas to elevate your bathroom:</p>
      <h3>Spa-Inspired Features</h3>
      <p>Install a rainfall shower head, body jets, and a steam system to create a true spa experience at home. Heated floors add comfort during cooler months.</p>
      <h3>Freestanding Tubs</h3>
      <p>A sculptural freestanding tub becomes the focal point of your bathroom. Choose from classic clawfoot designs or sleek modern silhouettes.</p>
      <h3>Smart Technology</h3>
      <p>Digital shower controls, smart mirrors with built-in lighting and defoggers, and touchless faucets bring convenience and luxury together.</p>
      <h3>Natural Materials</h3>
      <p>Incorporate natural stone, wood accents, and plants to create a calming, organic atmosphere. Large format tiles minimize grout lines for a clean look.</p>
      <h3>Ambient Lighting</h3>
      <p>Layer your lighting with dimmer switches, LED strips, and statement fixtures. Proper lighting enhances both functionality and ambiance.</p>
      <h3>Storage Solutions</h3>
      <p>Floating vanities, recessed medicine cabinets, and built-in niches keep your space organized while maintaining a minimalist aesthetic.</p>
      <h3>Color Palette</h3>
      <p>Neutral tones create a timeless backdrop, while accent colors in towels and accessories add personality. Consider matte black fixtures for a contemporary edge.</p>
      <p>Let Renova8 & Build transform your bathroom into the luxurious sanctuary you deserve. Contact us for a personalized consultation.</p>
    `,
  date: 'January 5, 2025',
  author: 'Renova8 Design Team'
}];
export function Blog() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <section id="blog" className="py-12 sm:py-16 md:py-20 bg-[#1c1c1c]" ref={ref} data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-73">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-74">
            Insights & <span className="text-[#d4af37]" data-id="element-75">Tips</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto px-4" data-id="element-76">
            Expert advice and inspiration for your renovation journey
          </p>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-77">
          {posts.map((post, index) => <motion.article key={post.title} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group bg-[#0f0f0f] rounded-lg overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-[#d4af37]/20 active:scale-95" data-id="element-78">
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden" data-id="element-79">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-80" />
              </div>
              <div className="p-4 sm:p-6" data-id="element-81">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3 group-hover:text-[#d4af37] transition-colors" data-id="element-82">
                  {post.title}
                </h3>
                <p className="text-gray-400 text-sm sm:text-base mb-3 sm:mb-4" data-id="element-83">
                  {post.excerpt}
                </p>
                <Link to={`/blog/${post.slug}`} className="flex items-center gap-2 text-[#d4af37] font-semibold group-hover:gap-4 transition-all text-sm sm:text-base" data-id="element-84">
                  Read More
                  <ArrowRightIcon className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-85" />
                </Link>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}